<template>
  <div class="positions-picker">
    <div class="d-flex mt-2 full-width">
      <v-select
        v-model="selectPickerValue"
        :items="positions"
        item-text="full_name"
        item-value="id"
        outlined
        :multiple="selectMultiple"
        chips
        :hint="selectedPositionsHint"
        :hide-details="!selectedPositionsHint"
        persistent-hint
        single-line
        placeholder="Välj platser"
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index === 0" small color="secondary">
            <span>{{ item.full_name }}</span>
          </v-chip>
          <v-chip v-else-if="index === 1" small color="secondary">
            <span>{{ item.full_name }}</span>
          </v-chip>
          <span
            v-if="index === 2"
            class="grey--text text-caption"
          >
            (+{{ selectedPositionIds.length - 2 }} till)
          </span>
        </template>
      </v-select>
      <div class="ml-4 d-flex align-center" style="height: 56px;">
        <slot name="side-button"></slot>
      </div>
    </div>

    <div class="d-flex my-2">
      <v-btn
        v-show="showSelectAllPositionsButton && selectMultiple"
        @click="selectAllPositions"
        small
        outlined
        color="primary"
        class="mr-2"
      >
        Markera alla platser
      </v-btn>
      <v-btn
        v-show="showUnselectAllPositionsButton && selectMultiple"
        @click="unselectAllPositions"
        small
        outlined
        color="primary"
        class="mr-2"
      >
        Avmarkera alla platser
      </v-btn>
      <v-btn
        @click="showMapDialog = true"
        small
        color="secondary"
        outlined
      >
        {{ selectMultiple ? 'Välj platser på områdeskartan' : 'Välj plats på områdeskartan' }}
      </v-btn>
    </div>

    <v-dialog v-model="showMapDialog" content-class="large-dialog">
      <v-btn icon style="position: absolute; top: 10px; right: 10px; z-index: 2;" @click="showMapDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card>
        <position-picker-map
          v-model="selectedPositionIds"
          :positions-filter="positionsFilter"
          :select-multiple="selectMultiple"
        ></position-picker-map>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import PositionPickerMap from '@/components/position/PositionPickerMap.vue'

export default {
  name: 'PositionsPicker',
  components: {
    PositionPickerMap
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    positionsFilter: {
      type: Function,
      default: () => () => true
    },
    showSelectAllPositionsButton: {
      type: Boolean,
      default: true
    },
    showUnselectAllPositionsButton: {
      type: Boolean,
      default: true
    },
    selectMultiple: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    showMapDialog: false
  }),
  computed: {
    ...mapGetters(
      {
        activePositions: 'position/activePositions'
      }
    ),
    selectPickerValue: {
      get () {
        return this.selectMultiple ? this.selectedPositionIds : (this.selectedPositionIds[0] || null)
      },
      set (val) {
        if (this.selectMultiple) {
          this.selectedPositionIds = val
        } else {
          this.selectedPositionIds = val ? [val] : []
        }
      }
    },
    selectedPositionIds: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    positions: function () {
      return this.activePositions.filter(this.positionsFilter)
    },
    selectedPositionsHint: function () {
      if (!this.selectMultiple) {
        return ''
      }
      return `Valt ${this.selectedPositionIds.length} av ${this.positions.length} platser`
    }
  },
  methods: {
    selectAllPositions: function () {
      this.selectedPositionIds = this.positions.map(position => position.id)
    },
    unselectAllPositions: function () {
      this.selectedPositionIds = []
    }
  }
}
</script>
